import { Box, Flex, Image } from 'dash-ui';
import styled from 'styled-components';

export const MediaFilterItemWrapper = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  cursor: pointer;

  :hover {
    & > div:last-child {
      display: flex;
    }
  }
  position: relative;
`;

export const ImageWrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.n20};
  overflow: hidden;
  border-radius: ${({ theme }) => {
    const radius = theme.space * 2;

    return `${radius}px ${radius}px 0 0`;
  }};
`;

export const ThumbnailView = styled(Image)`
  height: 100%;
  width: fit-content;
  border-radius: 0;
  width: 100%;
`;

export const Overlay = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 2;
`;

export const StyledButtonContainer = styled(Flex)`
  display: none;
  position: absolute;
  right: 5px;
  bottom: 5px;
  z-index: 3;

  & > div:first-child {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.b50};
  }

  @media ${({ theme }) => theme.devices.mobile} {
    display: flex;
  }
`;

export const StyledTopContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: unset;
  right: 12px;
  top: 12px;
  position: absolute;
  z-index: 3;
`;

export const ToggleContainer = styled(Box)`
  line-height: 16px;
`;

export const ButtonWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.white};

  button:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.b50};
  }
`;
